import { FC } from 'react';

type Props = {
    className?: string;
};

const DropletIconSolid: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="#2B2B2B"
            stroke="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4366 2.02349C11.0579 0.714176 8.94472 0.714176 7.56602 2.02349C6.49935 3.03648 5.19236 4.43281 4.1482 6.03446C3.10874 7.62892 2.29297 9.48292 2.29297 11.3982C2.29297 15.1214 5.21584 18.9582 10.0013 18.9582C14.7868 18.9582 17.7096 15.1214 17.7096 11.3982C17.7096 9.48292 16.8939 7.62893 15.8544 6.03446C14.8102 4.43281 13.5032 3.03648 12.4366 2.02349ZM12.5013 11.6664C12.5013 13.0472 11.3821 14.1664 10.0013 14.1664C9.54105 14.1664 9.16797 14.5396 9.16797 14.9998C9.16797 15.46 9.54105 15.8331 10.0013 15.8331C12.3025 15.8331 14.168 13.9677 14.168 11.6664C14.168 11.2063 13.7949 10.8331 13.3346 10.8331C12.8744 10.8331 12.5013 11.2063 12.5013 11.6664Z"
                fill="inherit"
            />
        </svg>
    );
};

export default DropletIconSolid;
